export default __webpack_public_path__ + "static/realization_3-dfff7da2397f0a0b5c46c911280f9a87.jpg";